import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { SectionCta } from './SectionCta';
type Bonus = {
  tag: string;
  title: string;
  value: string;
  promise: string;
  items: string[];
  image?: string;
  imageAlt?: string;
};
const BONUSES: Bonus[] = [{
  tag: 'Bono #1',
  title: 'Pack de Algoritmos Clínicos de TRT',
  value: 'USD 49',
  promise: '10 algoritmos imprimibles para resolver los escenarios más frecuentes en menos de un minuto.',
  items: ['Diagnóstico', 'Ajuste de dosis', 'PSA', 'Hematocrito', 'Estradiol', 'Fertilidad', 'Contraindicaciones', 'Suspensión'],
  image: 'https://cdn.magicpatterns.com/uploads/rvZaVPQdeYvb8pSvZPJ9a3/BONO_1_TRT.png',
  imageAlt: 'Pack de Algoritmos Clínicos de TRT: 10 algoritmos imprimibles'
}, {
  tag: 'Bono #2',
  title: 'Biblioteca de Casos Clínicos Resueltos',
  value: 'USD 97',
  promise: 'Más de 30 casos completamente desarrollados: aprenda exactamente cómo piensa un experto frente a pacientes reales.',
  items: ['Historia clínica', 'Laboratorios', 'Diagnóstico', 'Conducta', 'Seguimiento'],
  image: 'https://cdn.magicpatterns.com/uploads/sGWk94G9SQUhE8rFrbVyym/BONO_2_TRT.png',
  imageAlt: 'Biblioteca de Casos Clínicos Resueltos: más de 30 casos desarrollados'
}, {
  tag: 'Bono #3',
  title: 'Kit Profesional para la Consulta',
  value: 'USD 67',
  promise: 'Todo listo para utilizar desde mañana. Solo imprima y utilice.',
  items: ['Historia clínica específica para TRT', 'Consentimiento informado', 'Solicitud inicial de laboratorios', 'Hoja de seguimiento', 'Registro de dosis', 'Control de síntomas']
}, {
  tag: 'Bono #4',
  title: 'Calculadora Clínica de TRT',
  value: 'USD 79',
  promise: 'Automatice los cálculos que normalmente le toman varios minutos.',
  items: ['Testosterona libre', 'Dosis', 'Intervalos', 'Conversión de unidades', 'Fechas de seguimiento']
}, {
  tag: 'Bono #5',
  title: 'Guía de Resolución de Complicaciones',
  value: 'USD 57',
  promise: 'Cuando aparezca un problema, no tendrá que improvisar: protocolos paso a paso.',
  items: ['Hematocrito elevado', 'PSA elevado', 'Estradiol alto', 'Ginecomastia', 'Policitemia', 'Fertilidad', 'Ausencia de respuesta']
}];
export function Bonuses() {
  return <section className="w-full bg-navy-950 py-12 sm:py-16" aria-labelledby="bonuses-title" data-id="element-16" data-mp="2xtih1fdm6y2p">
      <div className="mx-auto w-full max-w-2xl px-4" data-id="element-17" data-mp="32td6dehqrfln">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.16em] text-gold-400" data-id="element-18" data-mp="32rsczs75y2pd">
          Pero eso no es todo…
        </p>
        <h2 id="bonuses-title" className="mt-3 text-center font-display text-[26px] font-bold leading-tight text-white sm:text-4xl" data-id="element-19" data-mp="2a4pfn3e83y0p">
          Hoy también recibirá estos 5 bonos exclusivos
        </h2>
        <p className="mt-3 text-center text-[14px] text-cream-100/75 sm:text-base" data-id="element-20" data-mp="27iyjvduoj2pz">
          Porque tomar decisiones seguras requiere mucho más que teoría.
        </p>

        <div className="mt-8 space-y-4" data-id="element-21" data-mp="1xlk3tfco4fy7">
          {BONUSES.map(bonus => <article key={bonus.tag} className="overflow-hidden rounded-3xl border border-gold-500/25 bg-white/[0.04]" data-id="element-22" data-mp="1xnodkdx9096e">
              {bonus.image ? <div className="bg-white px-4 py-4" data-id="element-23" data-mp="1omypjwe8bn38">
                  <img src={bonus.image} alt={bonus.imageAlt ?? bonus.title} className="mx-auto w-full max-w-[420px]" loading="lazy" data-id="element-24" data-mp="1jtdw8hnkzhad" />
                </div> : null}

              <div className="p-4 sm:p-5" data-id="element-25" data-mp="15v5tft3v5lra">
                <div className="flex flex-wrap items-center gap-2" data-id="element-26" data-mp="15tuqfvi8si18">
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-gold-500 px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-[0.12em] text-navy-950" data-id="element-27" data-mp="10wm6bpdja3xc">
                    <GiftIcon className="h-3 w-3" aria-hidden="true" data-id="element-28" data-mp="34zxjg4xib2nj" />
                    {bonus.tag}
                  </span>
                  <span className="text-[11px] font-semibold uppercase tracking-[0.1em] text-cream-100/55" data-id="element-29" data-mp="2r6y1zxe5yydc">
                    Valor: <s data-id="element-30" data-mp="2w5j7occ6qa96">{bonus.value}</s>
                  </span>
                  <span className="rounded-full bg-emerald-500/15 px-2 py-0.5 text-[10px] font-extrabold uppercase tracking-[0.12em] text-emerald-300" data-id="element-31" data-mp="2h9k1564q4i65">
                    Hoy: gratis
                  </span>
                </div>

                <h3 className="mt-3 font-display text-[19px] font-bold leading-snug text-white sm:text-2xl" data-id="element-32" data-mp="28apvkq9f0hgg">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-[14px] leading-relaxed text-cream-100/80" data-id="element-33" data-mp="6h8te24208t3">
                  {bonus.promise}
                </p>

                <ul className="mt-3.5 grid grid-cols-1 gap-1.5 sm:grid-cols-2" data-id="element-34" data-mp="bgd10obbxyhb">
                  {bonus.items.map(item => <li key={item} className="flex items-start gap-2" data-id="element-35" data-mp="lifjv3akjtax">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-400" aria-hidden="true" data-id="element-36" data-mp="gn9xy4h62emu" />
                      <span className="text-[13px] font-medium leading-snug text-cream-100/85" data-id="element-37" data-mp="plc8pbqpclnb">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>

        <SectionCta label="Quiero el sistema + los 5 bonos gratis" tone="dark" data-id="element-38" data-mp="1dc9ahvosa2ku" />
      </div>
    </section>;
}